import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { WandSparkles } from "lucide-react";
import { ButtonTertiary } from "src/UI/ButtonTertiary";
import MassiveStatusUploadModal from "./MassiveStatusUploadModal";

interface MassiveStatusUploadActionProps {
  corporateId: string | number;
  objectId: string | number;
  onUploaded?: () => void;
  // S05: azione visibile ma disabilitata senza permesso.
  disabled?: boolean;
}

const MassiveStatusUploadAction: React.FC<MassiveStatusUploadActionProps> = ({
  corporateId,
  objectId,
  onUploaded,
  disabled = false,
}) => {
  const { t } = useTranslation("enrollment-progress");
  const [open, setOpen] = useState(false);

  return (
    <>
      <ButtonTertiary
        size="sm"
        endIcon={<WandSparkles size={14} />}
        onClick={() => !disabled && setOpen(true)}
        disabled={disabled}
        sx={{
          textDecoration: "none",
          "&:hover": { textDecoration: "none" },
        }}
      >
        {t("massive.action")}
      </ButtonTertiary>
      {open && (
        <MassiveStatusUploadModal
          open={open}
          onClose={() => setOpen(false)}
          corporateId={corporateId}
          objectId={objectId}
          onUploaded={onUploaded}
        />
      )}
    </>
  );
};

export default MassiveStatusUploadAction;
